import { apiClient } from '../../../helpers/api_helper';

export const getAllStoreData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Store/GetAllStoreList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllStoreForSelect = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Store/GetStoresSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getStoreTypeForSelect = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Store/GetStoreTypeSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getStoreById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/store/GetStoreDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createStore = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Store/InsertStore', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateStore = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Store/UpdateStore', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteStore = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Store/DeleteStore?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};


export const GetStoresSelectListBySateIdAndCityId = async (data?: { stateId?: number[]; cityId?: number[] }) => {
    try {
        const params = new URLSearchParams();

        // Append each stateId (if any)
        data?.stateId?.forEach((id: number) => {
            params.append('stateId', id.toString());
        });

        // Append each cityId (if any)
        data?.cityId?.forEach((id: number) => {
            params.append('cityId', id.toString());
        });

        const queryString = params.toString();
        const url = `/api/v1/Store/GetStoresSelectListBySateIdAndCityId${queryString ? `?${queryString}` : ''}`;
        
        const response = await apiClient.get(url);
        return response;
    } catch (error) {
        console.error('Error fetching store list:', error);
        throw error;
    }
};
